/* eslint-disable no-shadow */
import {
  Breakpoint,
  BreakpointListener,
  Breakpoints,
  Option,
  RadioGroup,
} from '@op/opds.opux';
import { space } from '@op/opds.tokens';
import React, { ReactElement, useMemo, useState } from 'react';
import { Message, useMessage } from '@messageformat/react';
import CourseTaskHeader from '../CourseTaskHeader';
import { ReactComponent as Image013 } from '../../images/OP_symbolikuvitus_128_013.svg';

type Content = {
  columns: number;
};

const TaskOne = (): ReactElement => {
  const [value, setValue] = React.useState('');
  const [breakpoint, setBreakpoint] = useState<Breakpoint | null>(null);
  const [showQuestionOneResult, setShowQuestionOneResult] = useState(false);
  const questionOneArray = useMessage('course1.question1.answer_options');

  const content = breakpoint?.content ? (breakpoint.content as Content) : null;

  const breakpoints: Breakpoints = useMemo(() => {
    return [
      { from: 0, to: 767, content: { columns: 1 } },
      {
        from: 768,
        to: Number.MAX_SAFE_INTEGER,
        content: { columns: 2 },
      },
    ];
  }, []);

  return (
    <BreakpointListener breakpoints={breakpoints} onChange={setBreakpoint}>
      <div style={{ marginBottom: space.xxl }}>
        <div>
          <CourseTaskHeader questionNumber={1} totalQuestions={2} />
          <h3
            className="opds-styles-v1-text-hero-small"
            style={{ textAlign: 'center', marginTop: space.xxl }}
          >
            <Message id="course1.question1.title" />
          </h3>
          <div
            className="opds-styles-v1-text-body-medium"
            style={{
              textAlign: 'center',
              paddingBottom: space.default,
              paddingTop: space.default,
            }}
          >
            <Message id="course1.question1.body" />
          </div>
          <RadioGroup
            columns={content?.columns}
            buttons
            onChange={(_ev, value) => {
              setShowQuestionOneResult(true);
              setValue(value);
            }}
            value={value}
          >
            {Object.keys(questionOneArray).map((index, value) => {
              return (
                <Option
                  key={index}
                  value={index}
                  labelProps={{
                    style: { padding: '20px', alignItems: 'center', border: 0 },
                    className: 'investoracademy-radio-group-option',
                  }}
                >
                  <Message id={`${'course1.question1.answer_options'}.${value}`} />
                </Option>
              );
            })}
          </RadioGroup>
        </div>
        <div style={{ display: showQuestionOneResult ? 'block' : 'none' }}>
          <Image013
            className="investoracademy-small-svg"
            style={{
              marginTop: space.xxl,
            }}
            aria-hidden="true"
          />

          <div
            className="opds-styles-v1-text-title-small-strong"
            style={{ textAlign: 'center', color: '#EE5A00', paddingTop: space.default }}
          >
            <Message id="answer" />
          </div>
          <div
            className="opds-styles-v1-text-title-medium"
            style={{
              textAlign: 'center',
            }}
          >
            <Message id="course1.question1.answer.title" />
          </div>
          <div
            className="opds-styles-v1-text-body-medium"
            style={{
              textAlign: 'center',
              paddingBottom: space.default,
              paddingTop: space.small,
            }}
          >
            {value !== '' && (
              <Message id={`${'course1.question1.answer.body'}.${value}`} />
            )}
          </div>
        </div>
      </div>
    </BreakpointListener>
  );
};

export default TaskOne;
